import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AccessTokenRequestBody } from '@app/store/auth/types';
import { callbackResponseDto } from '@app/models/dtos/callbackResponseDto';
import environments from '@app/configs/environments';

export const OAUTH_PATH = 'oauth';

export const oauthApi = createApi({
    reducerPath: OAUTH_PATH,
    baseQuery: fetchBaseQuery({
        baseUrl: environments.CLIENT_SIDE_ENDPOINT_HOST
    }),
    endpoints: (builder) => ({
        getAccessToken: builder.query<callbackResponseDto, AccessTokenRequestBody>({
            query: (requestBody) => ({
                url: '/api/oauth/callback',
                method: 'POST',
                body: requestBody,
                credentials: 'include'
            })
        })
    })
});

export const { useGetAccessTokenQuery } = oauthApi;
